import {
  EnvironmentConfigSettings,
  ReadOnlyEnvironmentConfig,
} from './environment-config.model';

export function environmentConfigFactory(
  config: EnvironmentConfigSettings,
): ReadOnlyEnvironmentConfig {
  return {
    settings: {
      ...config,
    },
    appInsightsConfig: {
      instrumentationKey: `${config.appInsightsInstrumentationKey}`,
    },
    api: {
      root: config.understandingDyslexiaApiPath,
      downloadCertificate: `${config.understandingDyslexiaApiPath}generateCertificate`,
      course: `${config.understandingDyslexiaApiPath}course`,
      progress: {
        trainee: `${config.understandingDyslexiaApiPath}progress`,
        videoWatched: `${config.understandingDyslexiaApiPath}progress/AddVideoWatched`,
        quizAnswered: `${config.understandingDyslexiaApiPath}progress/AddQuizAnswered`,
        reset: `${config.understandingDyslexiaApiPath}reset`,
      },
      identity: {
        root: `${config.identityApiPath}`,
        understandingdyslexia: {
          list: `${config.identityApiPath}ud/trainees`,
          saveTrainee: `${config.identityApiPath}ud/trainee/upsert`,
          delete: `${config.identityApiPath}ud/trainee/delete`,
          reinvite:`${config.identityApiPath}ud/trainee/reinvite`
        },
        accountUser: {
          emailExists: `${config.identityApiPath}accountuser/exists`,
        },
      },

      ping: `${config.understandingDyslexiaApiPath}ping`,
    },
  };
}
